
import React, { useState } from "react";
import { Investor } from "@/types/investor";
import { ScrollArea } from "@/components/ui/scroll-area";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";
import InvestorSourcesDialog from "./InvestorSourcesDialog";
import InvestorDetailsDialog from "./InvestorDetailsDialog";
import InvestorListItem from "./InvestorListItem";

interface InvestorsListViewProps {
  investors: Investor[];
  selectedInvestor: Investor | null;
  onSelectInvestor: (investor: Investor) => void;
  isEnriching: boolean;
  onEnrichInvestor?: (investor: Investor) => Promise<Investor>;
  isInvestorEnriching?: (id: string) => boolean;
  isInvestorProcessed?: (investor: Investor) => boolean;
}

const InvestorsListView = ({ 
  investors, 
  selectedInvestor, 
  onSelectInvestor,
  isEnriching,
  onEnrichInvestor,
  isInvestorEnriching,
  isInvestorProcessed = () => false
}: InvestorsListViewProps) => {
  const [sourceDialogInvestor, setSourceDialogInvestor] = useState<Investor | null>(null);
  const [viewDialogInvestor, setViewDialogInvestor] = useState<Investor | null>(null);
  
  return (
    <div className="rounded-md border">
      <ScrollArea className="h-[500px]">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="sticky top-0 bg-background z-10">Firm</TableHead>
              <TableHead className="sticky top-0 bg-background z-10">Relevance Score</TableHead>
              <TableHead className="sticky top-0 bg-background z-10">Investment Focus</TableHead>
              <TableHead className="sticky top-0 bg-background z-10">Status</TableHead>
              <TableHead className="sticky top-0 bg-background z-10">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {investors.length > 0 ? (
              investors.map((investor) => (
                <InvestorListItem
                  key={investor.id}
                  investor={investor}
                  isSelected={selectedInvestor?.id === investor.id}
                  isEnriching={isEnriching}
                  onSelectInvestor={onSelectInvestor}
                  onEnrichInvestor={onEnrichInvestor}
                  isInvestorEnriching={isInvestorEnriching}
                  isInvestorProcessed={isInvestorProcessed}
                  onViewInvestor={(inv) => setViewDialogInvestor(inv)}
                  onShowSources={(inv) => setSourceDialogInvestor(inv)}
                />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} className="h-24 text-center">
                  No investors found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </ScrollArea>

      {/* Dialog to show sources */}
      <InvestorSourcesDialog 
        investor={sourceDialogInvestor} 
        onClose={() => setSourceDialogInvestor(null)} 
      />

      {/* Dialog to show detailed investor information */}
      <InvestorDetailsDialog 
        investor={viewDialogInvestor} 
        onClose={() => setViewDialogInvestor(null)} 
      />
    </div>
  );
};

export default InvestorsListView;
